import { cx } from './cx';
import styles from './PixelSpinner.module.css';

/** 3-frame pixel spinner (§5.1). Static in reduced motion. Decorative: pair with text. */
export function PixelSpinner({ className }: { className?: string }) {
  return (
    <span className={cx(styles.spinner, className)} aria-hidden="true">
      <span />
      <span />
      <span />
    </span>
  );
}
